module.exports = __webpack_public_path__ + "img/9788936456719.fe8ab248.jpg";